import { render, staticRenderFns } from "./bannerDown.vue?vue&type=template&id=58ce605e&scoped=true"
import script from "./bannerDown.vue?vue&type=script&lang=js"
export * from "./bannerDown.vue?vue&type=script&lang=js"
import style0 from "./bannerDown.vue?vue&type=style&index=0&id=58ce605e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce605e",
  null
  
)

export default component.exports